import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { SaleType, createCardSorts } from '@sorare/core/src/lib/algolia';

import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { clubPageFilters } from '@sorare/marketplace/src/searchCards/nba/cardFilters';

import { NBACardSearch } from 'components/searchCards/NBACardSearch';

import type { NBATeamSearch_team } from './__generated__/index.graphql';

type Props = {
  team: NBATeamSearch_team;
};

const cardSorts = createCardSorts({ withHighestAverageScore: true });

export const Search = ({ team }: Props) => {
  const filters = useDefaultFilters({
    teamSlug: team.slug,
  });

  return (
    <FullWidthContainer>
      <NBACardSearch
        analyticsTags={['Team', 'NBA']}
        topic={{ type: 'team', label: team.name }}
        defaultFilters={filters}
        cardFilters={clubPageFilters}
        sorts={cardSorts}
        defaultSort="Newly Listed"
        stackableTypes={[SaleType.PRIMARY_OFFER]}
      />
    </FullWidthContainer>
  );
};

Search.fragments = {
  team: gql`
    fragment NBATeamSearch_team on TeamInterface {
      slug
      name
    }
  ` as TypedDocumentNode<NBATeamSearch_team>,
};
